import './user-pages.sass';
import { useState, useEffect } from 'react';
import axios from 'axios';
import defaultAvatar from '../assets/default-avatar.svg';
import useAlert from '../hooks/useAlert';
import useUser from '../hooks/useUser';
import { useTranslation } from 'react-i18next';

const Account = () => {
	const { t, i18n } = useTranslation();
	const [editing, setEditing] = useState(false);
	const [waiting, setWaiting] = useState(false);
	const { sendAlert } = useAlert();
	const { user, getUser } = useUser();
	const token = localStorage.getItem('token');
	const accountId = localStorage.getItem('accountId');

	const [form, setForm] = useState({
		firstName: '',
		lastName: '',
		phone: '',
		residenceAddress: '',
		avatar: '',
	});

	useEffect(() => {
		const { firstName, lastName, phone, residenceAddress, avatar } = user;
		setForm({
			firstName: firstName || '',
			lastName: lastName || '',
			phone: phone || '',
			residenceAddress: residenceAddress || '',
			avatar: avatar || '',
		});
	}, [user]);

	const inputChange = (value, field) => {
		setForm({ ...form, [field]: value });
	}

	const cancelForm = () => {
		setEditing(false);
		setForm({
			...form,
			avatar: user.avatar,
		});
	}

	const checkForm = (event) => {
		event.preventDefault();
		let hasError = false;

		if (!hasError) {
			submitForm();
		}
	}

	const submitForm = () => {
		axios.put(`/user/update_user/${accountId}`, {
			accountId,
			avatar: form.avatar,
			firstName: form.firstName,
			lastName: form.lastName,
			phone: form.phone,
			residenceAddress: form.residenceAddress,
		}, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		}).then((response) => {
			const message = response.data.message;
			if (message === 'success') {
				getUser();
				setEditing(false);
			}
		}).catch((error) => {
			const message = error.response.data.message;
			switch (message) {
				default:
					sendAlert('Oops!', t('profile.msg_error_edit'));
					break;
			}
		});
	}

	const uploadImage = (event) => {
		setWaiting(true);
		const file = event.target.files[0];
		if (file) {
			const formData = new FormData();
			formData.append('file', file, file.name);
			axios.post('/items/upload_ipfs', formData, {
				headers: {
					Authorization: `Bearer ${token}`,
				}
			}).then((response) => {
				const message = response.data.message;
				const data = response.data.data;
				if (message === 'success') {
					setWaiting(false);
					inputChange(data.ipfsUri, 'avatar');
				}
			}).catch((error) => {
				setWaiting(false);
				const message = error.response.data.message;
				switch (message) {
					default:
						sendAlert('Oops!', t('profile.msg_error_upload'));
						break;
				}
			});
		} else {
			setWaiting(false);
		}
	}

	return (
		<div id='Account' className='user-pages'>
			<div className='page-title'>{t('navbar.menu_setting')}</div>

			<div className='page-content'>
				<form className='form' onSubmit={(event) => { event.preventDefault() }}>
					<label className='avatar' style={{ backgroundImage: `url(${form.avatar || defaultAvatar})`, cursor: editing ? 'pointer' : null }}>
						{editing ? (<div className='text' style={{color: '#FFF', fontSize: '16px', textShadow: '#000 1px 0 10px'}}>{waiting ? null : t('profile.msg_upload_img')}</div>) : null}
						{editing ? (<input type='file' onChange={uploadImage} accept='image/jpg, image/jpeg, image/png' />) : null}
						{waiting ? (<progress style={{'width': '80%'}} value={null} />) : null}
					</label>
					<div className='input-flex-wrap'>
						<div className='label'>{t('profile.title_url')}</div>
						{editing ? (
							<input type='text' value={form.avatar} onChange={(e) => { inputChange(e.target.value, 'avatar') }} />
						) : (
							<div className='current-value'>{user.avatar}</div>
						)}
					</div>
					<div className='input-flex-wrap'>
						<div className='label'>{t('profile.title_first_name')}</div>

						{editing ? (
							<input type='text' value={form.firstName} onChange={(e) => { inputChange(e.target.value, 'firstName') }} />
						) : (
							<div className='current-value'>{user.firstName}</div>
						)}
					</div>
					<div className='input-flex-wrap'>
						<div className='label'>{t('profile.title_last_name')}</div>

						{editing ? (
							<input type='text' value={form.lastName} onChange={(e) => { inputChange(e.target.value, 'lastName') }} />
						) : (
							<div className='current-value'>{user.lastName}</div>
						)}
					</div>
					<div className='input-flex-wrap'>
						<div className='label'>{t('profile.title_phone')}</div>

						{editing ? (
							<input type='text' value={form.phone} onChange={(e) => { inputChange(e.target.value, 'phone') }} />
						) : (
							<div className='current-value'>{user.phone}</div>
						)}
					</div>

					<div className='input-flex-wrap'>
						<div className='label'>{t('profile.title_address')}</div>

						{editing ? (
							<input type='text' value={form.residenceAddress} onChange={(e) => { inputChange(e.target.value, 'residenceAddress') }} />
						) : (
							<div className='current-value'>{user.residenceAddress}</div>
						)}
					</div>

					{editing ? (
						<div className='button-wrap flex'>
							<button className='cancel' onClick={cancelForm}>{t('profile.btn_cancel')}</button>
							<button onClick={checkForm}>{t('profile.btn_submit')}</button>
						</div>
					) : (
						<div className='button-wrap'>
							<button onClick={() => {
								setEditing(true);
							}}>{t('profile.btn_edit')}</button>
						</div>
					)}

				</form>
			</div>

			<div className='monetization-block'>Google ad</div>
		</div>
	)
}

export default Account;